/**
 * Background Attachment enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BACKGROUND_ATTACHMENT {
	SCROLL = "scroll",
	LOCAL = "local",
	FIXED = "fixed"
}

export type BACKGROUND_ATTACHMENT_string = keyof typeof BACKGROUND_ATTACHMENT;

export const BACKGROUND_ATTACHMENT_default: BACKGROUND_ATTACHMENT_string = "SCROLL";
